import { useModal } from '@billy/design-system'
import React, { useCallback } from 'react'
import type { ReactNode } from 'react'

import { ModalId } from '../../../enums/modalId'
import { Scope } from '../../../enums/scope'
import { TrackingContext } from '../../../enums/trackingContext'
import { useComponentId } from '../../../hooks'
import { isAuthorized } from '../../../utils/isAuthorized'
import { UpgradeSubscriptionModal } from '../../Modal'
import * as Styled from './styles'

interface UpsellGuardProps {
  children: ReactNode
  scope: Scope
  trackingContext: TrackingContext
}

export const UpsellGuard = ({ children, scope, trackingContext }: UpsellGuardProps): ReactNode => {
  const upgradeModalId = useComponentId(ModalId.UpgradeSubscriptionModal)
  const { open: openUpgradeModal } = useModal(upgradeModalId)

  const hasUpsellScope = isAuthorized(scope)

  const handlePointerDown = useCallback(
    (event: React.PointerEvent<HTMLDivElement>) => {
      if (!hasUpsellScope) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      openUpgradeModal()
    },
    [hasUpsellScope, openUpgradeModal],
  )

  if (hasUpsellScope) {
    return (
      <Styled.UpsellGuardWrapper onPointerDown={handlePointerDown}>
        {children}
        <UpgradeSubscriptionModal id={upgradeModalId} trackingContext={trackingContext} />
      </Styled.UpsellGuardWrapper>
    )
  }

  return children
}
